import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight, Menu, X } from "lucide-react";
import {
  getLoginMarketingLinks,
  GRADIENT_BUTTON_STYLE,
} from "@constants/loginMarketingLinks";
import { useTranslation } from "react-i18next";
import { useUserData } from "@context/OAuth/AuthContext";

const NAV_ITEMS = [
  { label: "Home", key: "home" },
  { label: "How It Works", key: "howItWorks" },
  { label: "About Us", key: "aboutUs" },
  { label: "FAQ", key: "faq" },
];


const LoginMarketingHeader = () => {
  const { t } = useTranslation();
  const links = getLoginMarketingLinks();
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const navLinkClass =
    "text-[#7A7A7A] font-[600] text-md hover:text-[#0771EF] transition-colors cursor-pointer";

  return (
    <header className="w-full bg-white border-b border-gray-100 font-[Lato] sticky top-0 z-50 shadow-[0px_4px_4px_rgba(0,0,0,0.25)]">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-[72px] sm:h-[80px] gap-4">
          <a
            href={links.home}
            className="flex items-center gap-2 shrink-0 min-w-0"
            rel="noopener noreferrer"
          >
            <img
              src="/blueLogo.png"
              alt="Budget Fit Plan"
              className=""
            />
          </a>

          <nav
            className="hidden lg:flex items-center justify-center gap-8 xl:gap-10 flex-1"
            aria-label="Main navigation"
          >
            {NAV_ITEMS.map(({ label, key }) => (
              <a
                key={key}
                href={links[key]}
                className={navLinkClass}
                rel="noopener noreferrer"
              >
                {t(label)}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-5 ">
            <Link
              to="/login"
              className={`${location.pathname.startsWith("/login") ? "text-[#0771EF]" : "text-[#7A7A7A]"} font-[600] text-md`}
              aria-current="page"
            >
              {t("Login")}
            </Link>
            <a
              href={links.getStarted}
              className="rounded-full flex items-center justify-center gap-1.5 px-5 py-3 bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white "
              style={GRADIENT_BUTTON_STYLE}
              rel="noopener noreferrer"
            >
              {t("Get Started now")}
              <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
            </a>
          </div>

          <button
            type="button"
            className="lg:hidden p-2 text-[#374151] hover:text-[#0771EF]"
            onClick={() => setMobileOpen((o) => !o)}
            aria-expanded={mobileOpen}
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
          >
            {/* {mobileOpen ? (
              <X className="w-6 h-6" />
            ) : ( */}
              <Menu className="w-6 h-6" color="#000" />
            {/* )} */}
          </button>
        </div>
      </div>

      {/* Moved outside the inner container to let 'absolute' drop 
        perfectly below the header line across the full viewport width.
      */}
      {mobileOpen ? (
        <div className="lg:hidden absolute left-1/2 transform -translate-x-1/2 w-[93%] top-[72px] sm:top-[80px] bg-[#0575e6] p-4 rounded-[8px] space-y-1 shadow-lg z-50">
          {" "}
            {NAV_ITEMS.map(({ label, key }) => (
            <a
              key={key}
              href={links[key]}
              className="block text-white text-md font-semibold hover:opacity-80 transition-opacity"
              rel="noopener noreferrer"
              onClick={() => setMobileOpen(false)}
            >
              {t(label)}
            </a>
          ))}
          <div className="flex flex-col gap-2">
            <Link
              to="/login"
              className="text-white text-md font-semibold hover:opacity-80 transition-opacity"
              onClick={() => setMobileOpen(false)}
            >
              {t("Login")}
            </Link>
            <a
              href={links.getStarted}
              className="inline-flex items-center justify-center gap-1.5 px-5 py-3 rounded-full bg-white text-[#0575e6] text-md font-bold shadow-md hover:bg-gray-100 transition-colors"
              rel="noopener noreferrer"
              onClick={() => setMobileOpen(false)}
            >
              {t("Get Started now")}
              <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
            </a>
          </div>
        </div>
      ) : null}
    </header>
  );
};

export default LoginMarketingHeader;
